<div class="wrapper" *ngIf="product?.images?.length; else noPhoto">
  <div class="photoHeading">
    <span>Фото {{ selectedPhotoNumber }} из {{ product?.images?.length }}</span>
    <span class="primaryLabel" *ngIf="isPrimary(mainImg)"><mat-icon>star</mat-icon>Основное</span>
  </div>
  <div class="imageFrame">
  <button
    type="button"
    class="mainImage"
    aria-label="Открыть просмотр фото товара"
    (click)="openPhotoViewer()"
    (contextmenu)="onRightClick($event, mainImg)"
  >
    <img *ngIf="getImageUrl(mainImg) as mainImageUrl" [src]="mainImageUrl" [alt]="product?.description || 'Фото товара'" />
    <span class="zoomHint"><mat-icon>zoom_in</mat-icon></span>
  </button>
  </div>
  <div class="thumbs" *ngIf="(product?.images?.length || 0) > 1" aria-label="Фотографии товара">
    <button
      type="button"
      class="thumb"
      [class.selected]="isSelected(image)"
      [class.primary]="isPrimary(image)"
      [attr.aria-pressed]="isSelected(image)"
      [attr.aria-label]="'Показать фото ' + (index + 1) + (isPrimary(image) ? ', основное' : '')"
      [matTooltip]="isPrimary(image) ? 'Основное фото' : 'Фото ' + (index + 1)"
      *ngFor="let image of product?.images; let index = index"
      (click)="select(image)"
      (contextmenu)="onRightClick($event, image)"
    >
      <img *ngIf="getImageUrl(image) as imageUrl" [src]="imageUrl" alt="" loading="lazy" />
      <span class="primaryThumbMark" *ngIf="isPrimary(image)" aria-hidden="true"><mat-icon>star</mat-icon></span>
    </button>
  </div>
  <div class="selectedPhotoActions" aria-label="Действия с выбранным фото">
    <button *ngIf="!isPrimary(mainImg) || settingPrimary" mat-stroked-button type="button" class="primaryPhotoButton" [disabled]="busy || !mainImg" (click)="setPrimary(mainImg)" matTooltip="Основное фото используется в списках и карточке товара">
      <mat-icon *ngIf="!settingPrimary">star_outline</mat-icon>
      <mat-spinner *ngIf="settingPrimary" diameter="16"></mat-spinner>
      {{ settingPrimary ? 'Сохранение…' : 'Сделать основным' }}
    </button>
    <button mat-stroked-button type="button" class="deletePhotoButton" [disabled]="busy || !mainImg" (click)="requestRemove(mainImg)" aria-label="Удалить выбранное фото">
      <mat-icon *ngIf="!removing">delete_outline</mat-icon>
      <mat-spinner *ngIf="removing" diameter="16"></mat-spinner>
      {{ removing ? 'Удаление…' : 'Удалить фото' }}
    </button>
  </div>
</div>
<ng-template #noPhoto>
  <div class="no-photo" (contextmenu)="onRightClick($event, undefined)">
    <mat-icon>photo_camera</mat-icon>
    <span>Нет фото</span>
  </div>
</ng-template>

<input #photoFile type="file" accept="image/*" class="fileInput" (change)="uploadFromInput($event)" />
<div class="galleryActions">
  <button mat-stroked-button type="button" class="uploadButton" [disabled]="busy || !product" (click)="photoFile.click()" matTooltip="Фото добавится сразу после выбора файла">
    <mat-icon *ngIf="!uploading">add_photo_alternate</mat-icon>
    <mat-spinner *ngIf="uploading" diameter="16"></mat-spinner>
    {{ uploading ? 'Загрузка…' : 'Загрузить фото' }}
  </button>
  <button mat-icon-button type="button" class="urlButton" [disabled]="busy || !product" (click)="addImageFromUrl()" matTooltip="Добавить фото по ссылке" aria-label="Добавить фото по ссылке">
    <mat-icon>add_link</mat-icon>
  </button>
</div>
<div class="galleryError" *ngIf="photoError" role="alert">{{ photoError }}</div>
<div class="galleryStatus" *ngIf="photoStatus" role="status">{{ photoStatus }}</div>

<div class="contextMenuAnchor" [style.left]="menuTopLeftPosition.x" [style.top]="menuTopLeftPosition.y" [matMenuTriggerFor]="rightMenu"></div>
<mat-menu #rightMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item [disabled]="busy || !item || isPrimary(item)" (click)="setPrimary(item)"><mat-icon>star_outline</mat-icon>Сделать основным</button>
    <button mat-menu-item [disabled]="busy || !item" (click)="requestRemove(item)"><mat-icon>delete_outline</mat-icon>Удалить фото</button>
    <button mat-menu-item [disabled]="busy" (click)="photoFile.click()"><mat-icon>add_photo_alternate</mat-icon>Загрузить файл</button>
    <button mat-menu-item [disabled]="busy" (click)="addImageFromUrl()"><mat-icon>add_link</mat-icon>Добавить по ссылке</button>
  </ng-template>
</mat-menu>

<ng-template #deletePhotoDialog let-photo>
  <h2 mat-dialog-title>Удалить фото?</h2>
  <mat-dialog-content>
    <img class="deletePhotoPreview" [src]="photo.url" alt="Фото, выбранное для удаления" />
    <p>Будет удалено только это фото товара.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="photo.close(false)" cdkFocusInitial>Отмена</button>
    <button mat-flat-button type="button" color="warn" (click)="photo.close(true)">Удалить фото</button>
  </mat-dialog-actions>
</ng-template>
